module.exports = __webpack_public_path__ + "static/media/Gwynne Sitsker.7e7860af.png";